import { Routes } from '@angular/router';
import { AuthGuard } from './services/auth-guard.service';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'debug',
    loadComponent: () => import('./debug/debug.page').then( m => m.DebugPage)
  },
  {
    path: 'trip',
    loadComponent: () => import('./trip/trip.page').then( m => m.TripPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'start-trip',
    loadComponent: () => import('./start-trip/start-trip.page').then( m => m.StartTripPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'start-unloading',
    loadComponent: () => import('./start-unloading/start-unloading.page').then( m => m.StartUnloadingPage),
    canActivate: [AuthGuard],    
  },
  {
    path: 'finish-unloading',
    loadComponent: () => import('./finish-unloading/finish-unloading.page').then( m => m.FinishUnloadingPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'finish-trip',
    loadComponent: () => import('./finish-trip/finish-trip.page').then( m => m.FinishTripPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'start-loading',
    loadComponent: () => import('./start-loading/start-loading.page').then( m => m.StartLoadingPage)
  },
  {
    path: 'finish-loading',
    loadComponent: () => import('./finish-loading/finish-loading.page').then( m => m.FinishLoadingPage)
  },
  {
    path: 'add-remark',
    loadComponent: () => import('./add-remark/add-remark.page').then( m => m.AddRemarkPage)
  },
  // Vegmatrix routes
  {
    path: 'home-vegmatrix',
    loadComponent: () => import('./home-vegmatrix/home-vegmatrix.page').then((m) => m.HomeVegmatrixPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'trip-vegmatrix',
    loadComponent: () => import('./trip-vegmatrix/trip-vegmatrix.page').then( m => m.TripVegmatrixPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'start-trip-vegmatrix',
    loadComponent: () => import('./start-trip-vegmatrix/start-trip-vegmatrix.page').then( m => m.StartTripVegmatrixPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'start-unloading-vegmatrix',
    loadComponent: () => import('./start-unloading-vegmatrix/start-unloading-vegmatrix.page').then( m => m.StartUnloadingVegmatrixPage),
    canActivate: [AuthGuard],    
  },
  {
    path: 'finish-unloading-vegmatrix',
    loadComponent: () => import('./finish-unloading-vegmatrix/finish-unloading-vegmatrix.page').then( m => m.FinishUnloadingVegmatrixPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'finish-trip-vegmatrix',
    loadComponent: () => import('./finish-trip-vegmatrix/finish-trip-vegmatrix.page').then( m => m.FinishTripVegmatrixPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'start-loading-vegmatrix',
    loadComponent: () => import('./start-loading-vegmatrix/start-loading-vegmatrix.page').then( m => m.StartLoadingVegmatrixPage)
  },
  {
    path: 'finish-loading-vegmatrix',
    loadComponent: () => import('./finish-loading-vegmatrix/finish-loading-vegmatrix.page').then( m => m.FinishLoadingVegmatrixPage)
  },
  {
    path: 'add-remark-vegmatrix',
    loadComponent: () => import('./add-remark-vegmatrix/add-remark-vegmatrix.page').then( m => m.AddRemarkVegmatrixPage)
  },
  {
    path: 'debug-vegmatrix',
    loadComponent: () => import('./debug-vegmatrix/debug-vegmatrix.page').then( m => m.DebugVegmatrixPage)
  },
];
